import React from "react";

const CreditPankh = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>CreditPankh</h2>
        <p>Content for CreditPankh page will go here.</p>
      </div>
    </div>
  );
};

export default CreditPankh;
